import type { ComponentProps } from "react";
import { Toaster as ReactToaster } from "react-hot-toast";

type ToasterProps = ComponentProps<typeof ReactToaster>;

const Toaster = ({ ...props }: ToasterProps) => {
  return (
    <ReactToaster
      containerClassName="toaster group"
      toastOptions={{
        style: {
          backgroundColor: "var(--gray-subtle-bg)",
          color: "var(--gray-fg-primary)",
          border: "1px solid var(--gray-border-subtle)",
          boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
          overflowWrap: "anywhere",
        },
        error: {
          style: {
            backgroundColor: "var(--destructive-subtle-bg)",
            color: "var(--gray-fg-primary)",
            border: "1px solid var(--destructive-border-subtle)",
          },
        },
        success: {
          style: {
            backgroundColor: "var(--accent-subtle-bg)",
            color: "var(--gray-fg-primary)",
            border: "1px solid var(--accent-border-subtle)",
          },
        },
      }}
      {...props}
    />
  );
};

export { Toaster };
